import { Container, Dialog, Stack } from '@mui/material';
import { useSnackbar } from '@/commons/snackbar';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCashRegisterService } from '@/services/cash-register';
import { errorCashRegister, warningCashRegister } from '@/utils/errors';
import CashRegisterNewEditForm from '../../form/cash_create';
import { translates } from '@/utils';

interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}

export function CashRegisterCreatePage(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: createCashRegisterService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cash-register'] });
      enqueueSnackbar('Open Cash Register!');
    },
    onError: (value: any) => {
      const errorMessage = errorCashRegister[value?.message];
      const warningMessage = warningCashRegister[value?.message];

      enqueueSnackbar(errorMessage || warningMessage, {
        variant: errorMessage ? 'error' : 'warning',
      });
    },
  });
  const handleSubmit = async (dataForm: any) => {
    await mutateAsync(dataForm);
    handleClose();
  };
  return (
    <Dialog onClose={handleClose} open={open}>
      <Container maxWidth={false}>
        <Stack>
          <h2>{translates['cash-register.create']}</h2>
        </Stack>
        <CashRegisterNewEditForm onSave={handleSubmit} isLoading={false} />
      </Container>
    </Dialog>
  );
}
